export type {AvatarIconProps} from './types';
export {AvatarIcon} from './AvatarIcon';
